import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import LocationIcon from 'assets/img/svg/location-icon.svg'
import ShopIcon from 'assets/img/svg/shop-icon.svg'
import ClockIcon from 'assets/img/svg/clock-icon.svg'
import ClosedIcon from 'assets/img/svg/closed-icon.svg'
import { queries } from '~/constants/mediaQuery'

function StatusCard({ total, open, closed, tempClosed }) {
  return (
    <StatusGrid>
      <div className="status-card">
        <div className="card-info">
          <span>{total || 0}</span>
          <span>
            <FormattedMessage id="Locations" />
          </span>
        </div>
        <div className="card-icon total">
          <img src={LocationIcon} width="40px" alt="" />
        </div>
      </div>

      <div className="status-card">
        <div className="card-info">
          <span>{open || 0}</span>
          <span>
            <FormattedMessage id="Open" />
          </span>
        </div>
        <div className="card-icon open">
          <img src={ShopIcon} width="40px" alt="" />
        </div>
      </div>

      <div className="status-card">
        <div className="card-info">
          <span>{tempClosed || 0}</span>
          <span>
            <FormattedMessage id="Temporarily Closed" />
          </span>
        </div>
        <div className="card-icon temp">
          <img src={ClockIcon} width="40px" alt="" />
        </div>
      </div>
      <div className="status-card">
        <div className="card-info">
          <span>{closed || 0}</span>
          <span>
            <FormattedMessage id="Closed Permanently" />
          </span>
        </div>
        <div className="card-icon closed">
          <img src={ClosedIcon} width="40px" alt="" />
        </div>
      </div>
    </StatusGrid>
  )
}

const StatusGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5em;

  @media ${queries.less.sm} {
    display: none !important;
  }

  .status-card {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background-color: #fff;
    padding: 1.5rem;
    gap: 0.5rem;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);

    .card-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: start;

      > span:nth-child(1) {
        color: #1a202c;
        font-size: 2.25rem;
      }

      > span:nth-child(2) {
        color: #4a5568;
        font-size: 0.875rem;
      }
    }

    .card-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #f7fafc;
      border-radius: 8px;
      padding: 1rem;
      margin-left: auto;

      &.total {
        background-color: #8176f1;
      }

      &.open {
        background-color: #38a169;
      }

      &.closed {
        background-color: #c53030;
      }

      &.temp {
        background-color: #f6ad55;
      }
    }
  }
`

export default StatusCard
